import React from 'react';
import ShieldIcon from '../../assets/sheild.svg';
import VisaIcon from '../../assets/svg/visa.svg';
import MasterCardIcon from '../../assets/svg/mastercard.svg';
import PSIIcon from '../../assets/svg/pci-dss.svg';
import AMEXIcon from '../../assets/svg/amex.svg';
import './style.scss';
function Footer() {
	return (
		<div className="footerContainer">
			<div className="section1">
				<img src={ShieldIcon} className="shield-icon" alt="Shield Icon" />
				<div className="content">100% Secure Payments Powered by Paytm</div>
			</div>
			<div className="section2">
				<img src={VisaIcon} className="shield-icon" alt="Visa Icon" />
				<img src={MasterCardIcon} className="shield-icon" alt="MasterCard Icon" />
				<img src={PSIIcon} className="shield-icon" alt="PSI DSS Icon" />
				<img src={AMEXIcon} className="shield-icon" alt="AMEX Icon" />
			</div>
		</div>
	);
}
export default Footer;
